import { useState } from "react";

export default function AdminPromo() {

const [chartId, setChartId] = useState("");
const [plan, setPlan] = useState("GROWTH");
const [link, setLink] = useState("");
const [code, setCode] = useState("");

const generate = async () => {

if (!chartId) {
alert("Enter chart ID");
return;
}

const spec = `${plan}:3d:1`;

const token = localStorage.getItem("admin_token");

const res = await fetch("http://localhost:8000/admin/promo/create-auto", {
method: "POST",
headers: {
"Content-Type": "application/json",
"Authorization": `Bearer ${token}`
},
body: JSON.stringify({
spec: spec,
notes: `chart=${chartId}`
})
});

const data = await res.json();

if (!data.ok) {
alert("Promo generation failed: " + (data.error || ""));
return;
}

const unlockLink =
`${window.location.origin}/unlock?code=${data.code}&chart_id=${chartId}`;

setCode(data.code);
setLink(unlockLink);
};


const copyLink = () => {
navigator.clipboard.writeText(link);
alert("Activation link copied");
};

return ( <div style={{padding:40,maxWidth:600}}>


  <h2>Promo Activation Generator</h2>

  <div style={{marginTop:20}}>
    <label>Chart ID</label>
    <input
      value={chartId}
      onChange={(e)=>setChartId(e.target.value)}
      placeholder="839214"
      style={{width:"100%",padding:8}}
    />
  </div>

  <div style={{marginTop:20}}>
    <label>Plan</label>

    <select
      value={plan}
      onChange={(e)=>setPlan(e.target.value)}
      style={{width:"100%",padding:8}}
    >
      <option value="PREMIUM_UNLOCK">Premium Unlock</option>
      <option value="GROWTH">Growth</option>
      <option value="INSIGHT">Insight</option>
    </select>

  </div>

  <button
    onClick={generate}
    style={{
      marginTop:20,
      padding:"10px 16px",
      cursor:"pointer"
    }}
  >
    Generate Activation Link
  </button>

  {code && (
    <div style={{marginTop:30}}>

      <p><strong>Promo Code:</strong> {code}</p>

      <p><strong>Activation Link</strong></p>

      <textarea
        value={link}
        readOnly
        style={{width:"100%",height:80}}
      />

      <button
        onClick={copyLink}
        style={{marginTop:10}}
      >
        Copy Link
      </button>

    </div>
  )}

</div>


);
}
